import { CSSProperties } from "react";

type Props = {
  alignItems?: CSSProperties["alignItems"];
  children: any;
  className?: string;
  flexDirection?: CSSProperties["flexDirection"];
  gap?: number;
  justifyContent?: CSSProperties["justifyContent"];
  style?: CSSProperties;
};

export function FlexBox({
  alignItems,
  children,
  className,
  flexDirection = "row",
  gap = 0,
  justifyContent,
  style = {},
}: Props) {
  return (
    <div
      className={className}
      style={{
        ...style,
        alignItems,
        display: "flex",
        flexDirection,
        gap,
        justifyContent,
      }}
    >
      {children}
    </div>
  );
}
